import { createSlice } from "@reduxjs/toolkit";
import { handleErrorState } from "../../utils/handleErrorState";
import { addRating, fetchBrandProducts, fetchCategoryProducts, fetchProductById, fetchProducts, filterProducts, getAllReviews, searchProducts } from "./productThunks";

const productsSlice = createSlice({
  name: 'products',
  initialState: {
    items: [],
    reviews: [],
    searchResults: [],
    currentItem: null,
    totalPages: 1,
    searchTotalPages : 1,
    loading: false,
    loadingReviews : false,
    backendProductErrors: {},
    serverError: {},
    networkError: null,
    unknownError: null
  },
  reducers: {
    clearProducts(state) {
      state.items = [];
      state.totalPages = 1;
    },

    clearSearchResults(state){
      state.searchResults = [];
      state.searchTotalPages = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.loading = true;
        state.backendProductErrors = {};
        state.serverError = null;
        state.networkError = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.items = action.payload.products;
        state.totalPages = action.payload.totalPages;
        state.loading = false;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        handleErrorState(state, action, "backendProductErrors");
      })

      .addCase(filterProducts.pending, (state) => {
        state.loading = true;
        state.backendProductErrors = {};
        state.serverError = null;
        state.networkError = null;
      })
      .addCase(filterProducts.fulfilled, (state, action) => {
        state.items = action.payload.products;
        state.totalPages = action.payload.totalPages;
        state.loading = false;
      })
      .addCase(filterProducts.rejected, (state, action) => {
        handleErrorState(state, action, "backendProductErrors");
      })

      .addCase(fetchBrandProducts.pending, (state) => {
        state.loading = true;
        state.backendProductErrors = {};
        state.serverError = null;
        state.networkError = null;
      })
      .addCase(fetchBrandProducts.fulfilled, (state, action) => {
        state.items = action.payload.products;
        state.totalPages = 1;
        state.loading = false;
      })
      .addCase(fetchBrandProducts.rejected, (state, action) => {
        handleErrorState(state, action, "backendProductErrors");
      })

      .addCase(fetchCategoryProducts.pending, (state) => {
        state.loading = true;
        state.backendProductErrors = {};
        state.serverError = null;
        state.networkError = null;
      })
      .addCase(fetchCategoryProducts.fulfilled, (state, action) => {
        state.items = action.payload.products;
        state.totalPages = 1;
        state.loading = false;
      })
      .addCase(fetchCategoryProducts.rejected, (state, action) => {
        handleErrorState(state, action, "backendProductErrors");
      })

      .addCase(fetchProductById.pending, (state) => {
        state.loading = true;
        state.backendProductErrors = {};
        state.serverError = {};
        state.networkError = null;
        state.currentItem = null;
      })
      .addCase(fetchProductById.fulfilled, (state, action) => {
        state.currentItem = action.payload;
        state.loading = false;
      })
      .addCase(fetchProductById.rejected, (state, action) => {
        state.loading = false;
        state.backendProductErrors = action.payload?.backendProductErrors;
        state.serverError = action.payload?.serverError;
        state.networkError = action.payload?.networkError;
        state.unknownError = action.payload?.unknownError;
      })

      .addCase(getAllReviews.pending, (state) => {
        state.loadingReviews = true;
        state.backendProductErrors = {};
        state.serverError = {};
        state.networkError = null;
      })
      .addCase(getAllReviews.fulfilled, (state, action) => {
        state.loadingReviews = false;
        state.reviews = action.payload;
      })
      .addCase(getAllReviews.rejected, (state, action) => {
        state.loadingReviews = false;
        state.backendProductErrors = action.payload?.backendProductErrors;
        state.serverError = action.payload?.serverError;
        state.networkError = action.payload?.networkError;
        state.unknownError = action.payload?.unknownError;
      })

      .addCase(addRating.pending, (state) => {
        state.loadingReviews = true;
        state.backendProductErrors = {};
        state.serverError = {};
        state.networkError = null;
        state.currentItem = null;
      })
      .addCase(addRating.fulfilled, (state, action) => {
        state.loadingReviews = false;
        state.reviews = state.reviews.push(action.payload.rating);
      })
      .addCase(addRating.rejected, (state, action) => {
        state.loadingReviews = false;
        state.backendProductErrors = action.payload?.backendProductErrors;
        state.serverError = action.payload?.serverError;
        state.networkError = action.payload?.networkError;
        state.unknownError = action.payload?.unknownError;
      })

      .addCase(searchProducts.pending, (state) => {
        state.loading = true;
        state.backendProductErrors = {};
        state.serverError = {};
        state.networkError = null;
        state.searchResults = [];
      })
      .addCase(searchProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.searchResults = action.payload.results;
        state.searchTotalPages = action.payload.totalPages;
      })
      .addCase(searchProducts.rejected, (state, action) => {
        state.loading = false;
        state.backendProductErrors = action.payload?.backendProductErrors;
        state.serverError = action.payload?.serverError;
        state.networkError = action.payload?.networkError;
        state.unknownError = action.payload?.unknownError;
      });
  }
});
export const { clearProducts , clearSearchResults } = productsSlice.actions;
export default productsSlice.reducer;